import { ClockIcon, EnvelopeOpenIcon } from "@heroicons/react/24/outline";
import React from "react";
import Button from "src/components/Shared/Buttons/Button";
import Input from "src/components/Shared/Forms/Inputs/Input";

const formatTime = (s) => {
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
};

export default function TwoFactorForm({ email, twoFactorDetails, disabledResendOtp, resendOtpSecond, resendOtp, otp, setOtp, error, otpVerify, isSubmitDisabled, otpSecond }) {
  return (
    <>
      <div>
        <p className="mb-1 text-sm text-gray-700">
          <EnvelopeOpenIcon className="mb-[1px] mr-2 inline-flex h-4 w-4 stroke-2" />
          If an account is linked to <span className="font-semibold">{twoFactorDetails?.email || email}</span>, a validation code will be sent to your email inbox.
        </p>

        <div className="m-6 ml-0 flex items-center text-sm text-gray-700">
          {disabledResendOtp || resendOtpSecond > 0 ? (
            <span className="ml-1">
              Please wait <ClockIcon className="mb-[2px] mr-[2px] inline-flex h-4 w-4 stroke-[2px]" />
              <span className="pr-[1px] font-semibold">{formatTime(resendOtpSecond)}</span> to resend another OTP
            </span>
          ) : (
            <>
              <span>Didn't receive a code?&nbsp;</span>
              <Button
                type="button"
                version="default"
                className="!h-auto !bg-transparent !px-1 !py-0 !opacity-100"
                onClick={resendOtp}
                disabled={disabledResendOtp || resendOtpSecond > 0}>
                <span className="text-gray-700 underline hover:text-gray-900">Resend</span>
              </Button>
              <span>&nbsp;verification email</span>
            </>
          )}
        </div>
      </div>

      <div className="flex w-full flex-col gap-y-3">
        <div className="w-full">
          <Input
            inline
            type="number"
            inputMode="numeric"
            autoComplete="one-time-code"
            name="contact-otp"
            label="OTP"
            error={Boolean(error)}
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && otpVerify(e)}
          />
        </div>

        <div className="mt-2">
          <Button
            width="w-full"
            type="submit"
            disabled={isSubmitDisabled || otpSecond > 0}>
            {otpSecond > 0 ? `You've been blocked for ${formatTime(otpSecond)}` : "Submit"}
          </Button>
        </div>
      </div>
    </>
  );
}
